<template>
	<v-menu bottom offset-y :close-on-content-click="false" class="mb-0">
		<template v-slot:activator="{ on, attrs }">
			<v-btn v-bind="attrs" v-on="on" icon small class="mr-2">
				<v-icon color="primary" small>mdi-plus-circle-outline</v-icon>
			</v-btn>
		</template>
		<v-list class="pa-4 max-width">
			<v-card>
				<v-tabs
					align-with-title
					class="d-flex justify-center"
					v-model="tab"
				>
					<v-tab href="#selectTag">
						{{
							$vuetify.lang.t(
								"$vuetify.views.tasks.tagMenu.selectTag"
							)
						}}
					</v-tab>
					<v-tab href="#addTag">
						{{
							$vuetify.lang.t(
								"$vuetify.views.tasks.tagMenu.addTag"
							)
						}}
					</v-tab>
				</v-tabs>

				<v-tabs-items v-model="tab">
					<v-tab-item class="mt-4" value="selectTag">
						<label class="subtitle-2 font-weight-bold">
							{{
								$vuetify.lang.t(
									"$vuetify.views.tasks.tagMenu.selectedTags"
								)
							}}
						</label>

						<div class="d-flex flex-wrap">
							<tag
								:key="tag.id"
								v-for="tag in selectedTags"
								:removalPossibility="false"
								:color="tag.color"
								:tagName="tag.name"
								class="mt-2"
							/>
						</div>

						<v-divider class="my-4" />

						<div class="tag-select-wrapper">
							<label class="subtitle-2 font-weight-bold">
								{{
									$vuetify.lang.t(
										"$vuetify.views.tasks.tagMenu.tagsList"
									)
								}}
							</label>

							<v-virtual-scroll
								v-if="items.length"
								:items="items"
								height="300"
								item-height="45"
							>
								<template v-slot:default="{ item, index }">
									<v-list-item>
										<v-checkbox
											:key="item.id"
											class="pa-0 ma-0 checkboxtag my-2"
											dense
											value="tag"
											@change="selectTag($event, item)"
											v-model="selectedCheckboxes[index]"
											:ripple="false"
										>
											<template v-slot:label>
												<tag
													:color="item.color"
													:removalPossibility="false"
													:tagName="item.name"
												/>
											</template>
										</v-checkbox>
									</v-list-item>
								</template>
							</v-virtual-scroll>
						</div>
					</v-tab-item>

					<v-tab-item class="mt-4" value="addTag">
						<label class="subtitle-2 font-weight-bold mt-4">
							{{
								$vuetify.lang.t(
									"$vuetify.views.tasks.tagMenu.tagName"
								)
							}}
						</label>
						<v-text-field
							:rules="requireRule"
							class="input-text caption font-weight-medium mt-2"
							dense
							outlined
							placeholder="Wpisz nazwę"
							ref="newTagName"
							v-model="newTagName"
							maxlength="20"
						>
						</v-text-field>
						<label class="subtitle-2 font-weight-bold">
							{{
								$vuetify.lang.t(
									"$vuetify.views.tasks.tagMenu.selectColor"
								)
							}}
						</label>
						<v-color-picker
							class="mt-2"
							dot-size="12"
							hide-mode-switch
							mode="hexa"
							ref="newTagColor"
							swatches-max-height="200"
							width="250"
							v-model="newTagColor"
						></v-color-picker>
						<div class="d-flex flex-column align-strech">
							<v-btn
								:loading="loading"
								@click="addTag()"
								color="accent"
							>
								{{
									$vuetify.lang.t(
										"$vuetify.views.tasks.tagMenu.createAndSelect"
									)
								}}
							</v-btn>
						</div>
					</v-tab-item>
				</v-tabs-items>
			</v-card>
		</v-list>
	</v-menu>
</template>

<script>
import Tag from "@/components/tasks/Tag.vue";

import { mapActions, mapGetters } from "vuex";
import axios from "axios";

export default {
	components: {
		Tag,
	},

	props: {
		propsTags: Array,
	},

	data() {
		return {
			loading: false,
			tab: "",
			newTagName: "",
			newTagColor: '#000000',
			requireRule: [
				(v) =>
					!!v ||
					this.$vuetify.lang.t(
						"$vuetify.views.tasks.validation.tagname"
					),
			],
			selectedTags: this.propsTags || [],
			selectedCheckboxes: [],
		};
	},
	computed: {
		...mapGetters({
			items: "tasks/tags",
		}),
	},

	watch: {
		selectedTags() {
			this.$emit("selectTag", this.selectedTags);
		},
	},

	methods: {
		...mapActions("tasks", ["postTag"]),
		async addTag() {
			const name = this.newTagName;
			const color = this.newTagColor;

			if (name && color) {
				this.loading = true;
				const res = await this.postTag({ name, color });
				if (res.success) {
					this.$refs.newTagName && this.$refs.newTagName.reset();
					this.newTagColor = "#000000";
					this.tab = "selectTag";
					this.selectedTags.push(res.tag);
					this.selectedCheckboxes[this.items.length - 1] = "tag";
					this.selectedCheckboxes = Object.assign(
						[],
						this.selectedCheckboxes
					);
				}
				this.loading = false;
			}
		},
		selectTag(checked, tag) {
			if (checked) {
				this.selectedTags.push(tag);
			} else {
				const idx = this.selectedTags.findIndex(
					(item) => item.id === tag.id
				);
				this.selectedTags.splice(idx, 1);
			}
		},

		async getTags() {
			this.isLoading = true;

			axios
				.get(`tags/tasks`, {
					params: {
						page: this.page,
					},
				})
				.then((response) => {
					this.items.push(...response.data.data);
				})
				.catch((error) => {
					console.log("GET TAGS ERROR", error);
					this.isLoading = false;
				});
		},
	},

	async created() {
		if (this.propsTags) {
			this.propsTags.forEach((tag) => {
				const i = this.items.findIndex((item) => item.id === tag.id);

				if (i !== -1) {
					this.selectedCheckboxes[i] = "tag";
				}
			});
		}

		this.selectedCheckboxes = Object.assign([], this.selectedCheckboxes);
	},
};
</script>

<style lang="scss" scoped>
.max-width {
	max-width: 290px;
}
</style>

<style>
a.v-tab {
	text-transform: unset;
	border-bottom: 1px solid var(--v-grey-lighten4);
}

.v-slide-group__content.v-tabs-bar__content {
	gap: 8px;
}

canvas {
	border-radius: 8px;
}
</style>
